import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../Service/ApiService";
import "./index.css";
import Header from "../../common/Header";
import { Button, Input, Space, Table, Tag } from "antd";
import { EditTwoTone } from "@ant-design/icons";

const ManageBookingsPage = () => {
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const columns = [
    {
      title: "No.",
      key: "no",
      render: (_, _record, idx) => idx + 1,
      width: 60,
    },
    {
      title: "Booking Confirmation Code",
      dataIndex: "bookingConfirmationCode",
      key: "bookingConfirmationCode",
    },
    {
      title: "Check-in Date",
      dataIndex: "checkInDate",
      key: "checkInDate",
    },
    {
      title: "Check-out Date",
      dataIndex: "checkOutDate",
      key: "checkOutDate",
    },
    {
      title: "Total Guests",
      dataIndex: "totalNumOfGuests",
      key: "totalNumOfGuests",
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        if (record.deleted) return <Tag>Archived</Tag>;
        if (record.completed) return <Tag color="purple">Completed</Tag>;
        if (record.confirmed) return <Tag color="blue">Confirmed</Tag>;
        return <Tag color="orange">Awaiting Confirmation</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <EditTwoTone
            twoToneColor="#0000ff"
            style={{ cursor: "pointer", fontSize: "16pt" }}
            onClick={() =>
              navigate(`/admin/edit-booking/${record.bookingConfirmationCode}`)
            }
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    const fetchBookings = async () => {
      const response = await ApiService.getAllBookings();
      setBookings(response);
      setFilteredBookings(response);
    };

    fetchBookings();
  }, []);

  useEffect(() => {
    filterBookings(searchTerm);
  }, [searchTerm, bookings]);

  const filterBookings = (term) => {
    if (term === "") {
      setFilteredBookings(bookings);
    } else {
      const filtered = bookings.filter(
        (booking) =>
          booking.bookingConfirmationCode &&
          booking.bookingConfirmationCode
            .toLowerCase()
            .includes(term.toLowerCase())
      );
      setFilteredBookings(filtered);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="default-container">
      <Header title={"Manage Bookings"} />
      <div className="booking-action-container">
        <Input
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Filter by Booking Number"
          style={{ maxWidth: 320 }}
          allowClear
        />
        <Button type="primary" onClick={() => navigate("/admin/create-booking")}>
          Create Booking
        </Button>
      </div>

      <Table
        dataSource={filteredBookings}
        columns={columns}
        rowKey="bookingConfirmationCode"
        pagination={{ position: ["bottomLeft"] }}
      />
    </div>
  );
};

export default ManageBookingsPage;
